<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template slot="iva" slot-scope="{ item }">
                        <span>{{ item.iva }} %</span>
                    </template>
                </g-table-sync>
            </div>
        </div>

        <custom-form :id="id" ref="form" :app="app" :view="view" :visible="formEnabled" @close="closeForm" />
    </div>
</template>

<script>
import customForm from './form'

export default {
    name: 'Articles',
    components: { customForm },
    data() {
        return {
            app: 'articles',
            view: 'articleList',
            columns: [
                {
                    title: 'ID',
                    index: '_EntityId',
                    search: true,
                },
                {
                    title: 'Nombre',
                    index: 'name',
                    order: true,
                    search: true,
                },
                {
                    title: 'Código EDI',
                    index: 'edi_code',
                    order: true,
                    search: true,
                },
                {
                    title: 'IVA',
                    index: 'iva',
                    order: true,
                    search: true,
                    slot: 'iva',
                },
                {
                    title: 'Orden',
                    index: 'order',
                    order: true,
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: '_actions',
                },
            ],
            formEnabled: false,
            id: 0,
        }
    },
    created() {
        this.$hub.$on('newArticle', () => {
            this.id = 0
            this.formEnabled = true
        })
    },
    beforeDestroy() {
        this.$hub.$off('newArticle')
    },
    methods: {
        openForm(item) {
            this.id = item._EntityId
            this.formEnabled = true
        },
        closeForm() {
            this.id = 0
            this.formEnabled = false
        },
    },
}
</script>

<style lang="scss"></style>
